"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const announcekit_react_1 = __importDefault(require("announcekit-react"));
const styled_components_1 = __importDefault(require("styled-components"));
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
const AccountContext_1 = require("contexts/AccountContext");
//
// assets
//
const navLogo_svg_1 = __importDefault(require("assets/images/dashboard/navLogo.svg"));
const polaris_1 = require("@shopify/polaris");
//
// components
//
const Dropdown = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Dropdown'))));
const NavigationSidebar = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./NavigationSidebar'))));
//
// styles
//
const StyledBottomContainer_1 = require("./StyledBottomContainer");
const StyledContainer_1 = require("./StyledContainer");
const StyledContent_1 = require("./StyledContent");
const StyledLogo_1 = require("./StyledLogo");
const StyledLogoContainer_1 = require("./StyledLogoContainer");
const StyledTopBar_1 = require("./StyledTopBar");
const RequiresFlag_1 = __importDefault(require("RequiresFlag"));
const RightSideContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: flex-end;
`;
const StyledAnnounceKit = (0, styled_components_1.default)(announcekit_react_1.default) `
  margin-right: 1.5rem;

  button {
    margin-right: 0rem;
  }
`;
const Layout = (props) => {
    const containerRef = (0, react_1.useRef)(null);
    const { account } = (0, AccountContext_1.useAccount)();
    const flags = (0, launchdarkly_react_client_sdk_1.useFlags)();
    const user = account
        ? {
            id: account.id,
            name: account.name
        }
        : undefined;
    return (react_1.default.createElement(StyledContainer_1.StyledContainer, { id: 'dashboard-container', ref: containerRef, style: { height: '100vh' } },
        react_1.default.createElement(StyledTopBar_1.StyledTopBar, null,
            react_1.default.createElement(StyledLogoContainer_1.StyledLogoContainer, null,
                react_1.default.createElement(StyledLogo_1.StyledLogo, { alt: 'Malomo', src: navLogo_svg_1.default })),
            react_1.default.createElement(RightSideContainer, null,
                react_1.default.createElement(RequiresFlag_1.default, { active: flags.announceKit },
                    react_1.default.createElement(StyledAnnounceKit, { user: user, widget: 'https://announcekit.co/widgets/v2/3xftGE' },
                        react_1.default.createElement(polaris_1.Button, { plain: true }, "What's New?"))),
                react_1.default.createElement(Dropdown, { onLogout: props.onLogout }))),
        react_1.default.createElement(StyledBottomContainer_1.StyledBottomContainer, null,
            react_1.default.createElement(NavigationSidebar, null),
            react_1.default.createElement(StyledContent_1.StyledContent, null,
                react_1.default.createElement(react_router_dom_1.Outlet, null)))));
};
exports.Layout = Layout;
